import type { CustomerCommentsStore } from './interfaces'

export const actions = {
  setLoading (this: CustomerCommentsStore, payload: CustomerCommentsStore['loading']): void {
    this.loading = payload
  },
  setLoadingMore (this: CustomerCommentsStore, payload: CustomerCommentsStore['loadingMore']): void {
    this.loadingMore = payload
  },
  setComments (this: CustomerCommentsStore, payload: CustomerCommentsStore['comments']): void {
    this.comments = payload
  },
  /** A further page continues the feed; rows already shown are not repeated. */
  appendComments (this: CustomerCommentsStore, payload: CustomerCommentsStore['comments']): void {
    const ids = new Set(this.comments.map(comment => comment.id))
    this.comments = [...this.comments, ...payload.filter(comment => !ids.has(comment.id))]
  },
  setNextCursor (this: CustomerCommentsStore, payload: CustomerCommentsStore['nextCursor']): void {
    this.nextCursor = payload
  },
  setFilterDisciplines (this: CustomerCommentsStore, payload: CustomerCommentsStore['filterDisciplines']): void {
    this.filterDisciplines = payload
  },
  reset (this: CustomerCommentsStore): void {
    this.comments = []
    this.nextCursor = null
  },
}
